<template>
    <div class="accordion mt-2 mb-5" id="accordionExample">
        <!-- Componente collapse para los jsons modelo 5
         filtros: el prop "Filtros" se utiiza para indicar cuantos selects hay en la vista-->
        <div v-for="(section, index) in sections" :key="index" class="card">
            <!-- <pre>{{ sections }}</pre> -->
            <div class="card-header" :id="'heading' + index">
            <h2 class="mb-0">
                <button
                class="btn btn-link btn-block text-left"
                type="button"
                data-toggle="collapse"
                :data-target="'#collapse' + index"
                aria-expanded="true"
                :aria-controls="'collapse' + index"
                style="display: flex; justify-content: space-between;"
                >
                <span class="titulo">
                    <p v-if="filtros == 1" class="m-0">{{ section.titulo_seccion }}</p>
                    <p v-if="filtros == 2" class="m-0">{{ section.subtitulo_seccion }}</p>
                </span>
                <span class="descargar"><i class="bx bx-chevron-down icono-down"></i></span>
                </button>
            </h2>
            </div>

            <div
                :id="'collapse' + index"
                class="collapse"
                :class="{ show: !collapse }"
                :aria-labelledby="'heading' + index"
                data-parent="#accordionExample"
            >
                <div v-if="filtros === 1" class="card-body">
                    <div class="container" v-for="(contenido, i) in section.contenido_seccion" :key="i">
                        <span v-if="contenido.subtitulo_seccion != ''" class="subtitulo fw-bold">{{ contenido.subtitulo_seccion }}</span>
                        <!-- <pre>{{ contenido }}</pre> -->
                        <div v-for="(contenido_subsub, subsub) in contenido.contenido" :key="subsub">
                            <span v-if="contenido_subsub.subsubtitulo_seccion != ''" class="subsubtitulo">{{ contenido_subsub.subsubtitulo_seccion }}</span> <!----CHECAAAR------->
                            <!-- <pre>{{ contenido_subsub }}</pre> -->

                            <ul>
                                <li class="container" v-for="(archivo, ar) in contenido_subsub.archivos_seccion" :key="ar">
                                    <div class="item-container row">
                                        <p class="item-name col-md-9 mb-0">{{ archivo.titulo }}<span v-if="archivo.pieTitulo" class="pie-titulo">{{archivo.pieTitulo}}</span></p>

                                        <div class="icons col-md-3">
                                            <a v-if="archivo.url_pdf" :href="urlServe + archivo.url_pdf" target="_blank" class="icon-pdf">
                                                <i class="fas fa-file-pdf"></i>
                                            </a>
                                            <a v-if="archivo.url_word" :href="urlServe + archivo.url_word" target="_blank" class="icon-word">
                                                <i class="fas fa-file-word"></i>
                                            </a>
                                            <a v-if="archivo.url_excel" :href="urlServe + archivo.url_excel" target="_blank" class="icon-excel">
                                                <i class="fas fa-file-excel"></i>
                                            </a>
                                            <a v-if="archivo.url_comprimido" :href="urlServe + archivo.url_comprimido" target="_blank" class="icon-rar">
                                                <i class="fas fa-file-archive"></i>
                                            </a>
                                            <a v-if="archivo.link" :href="archivo.link" target="_blank">
                                                <i class="fas fa-link icono-archivo icon-url"></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                        </div>


                    </div>
                </div>

                <div v-if="filtros === 2 " class="card-body">
                    <div class="container" v-for="(contenido, i) in section.contenido" :key="i">
                        <span v-if="contenido.subsubtitulo_seccion != ''" class="subtitulo mb-3">{{ contenido.subsubtitulo_seccion }}</span> <!----CHECAAAR------->
                            <!-- <pre>{{ contenido }}</pre> -->

                            <ul>
                                <li class="container" v-for="(archivo, ar) in contenido.archivos_seccion" :key="ar">
                                    <div class="item-container row">
                                        <p class="item-name col-md-9 mb-0">{{ archivo.titulo }}<span v-if="archivo.pieTitulo" class="pie-titulo">{{archivo.pieTitulo}}</span></p>
                                        <div class="icons col-md-3">
                                            <a v-if="archivo.url_pdf" :href="urlServe + archivo.url_pdf" target="_blank" class="icon-pdf">
                                                <i class="fas fa-file-pdf"></i>
                                            </a>
                                            <a v-if="archivo.url_word" :href="urlServe + archivo.url_word" target="_blank" class="icon-word">
                                                <i class="fas fa-file-word"></i>
                                            </a>
                                            <a v-if="archivo.url_excel" :href="urlServe + archivo.url_excel" target="_blank" class="icon-excel">
                                                <i class="fas fa-file-excel"></i>
                                            </a>
                                            <a v-if="archivo.url_comprimido" :href="urlServe + archivo.url_comprimido" target="_blank" class="icon-rar">
                                                <i class="fas fa-file-archive"></i>
                                            </a>
                                            <a v-if="archivo.link" :href="archivo.link" target="_blank">
                                                <i class="fas fa-link icono-archivo icon-url"></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div v-if="contenido.fecha_actualizacion" class="p-2 mx-4"><span v-html="DateFormatText(contenido.fecha_actualizacion)"></span></div>
                    </div>
                </div>
                <div v-if="section.fecha_actualizacion" class="p-2 mx-4"><span v-html="DateFormatText(section.fecha_actualizacion)"></span></div>
            </div>
        </div>
    </div>
  </template>

  <script>
  import DateFormat from "@/mixins/dateFormatMixin.js";
  export default {
    mixins: [DateFormat],
    props: {
      sections: {
        type: Array,
        required: true,
        // Estructura: [{ title: 'Title', items: [{ name: 'Item Name', path: 'item-path', pdf: 'pdf-path', word: 'word-path', excel: 'excel-path', rar: 'rar-path' }, ...] }, ...]
      },
      urlServe: {
        type: String,
        default: ''
      },
      collapse:{
        type: Boolean,
        default: true
      },
      filtros:{
        type: Number,
        default: 1
      }
    }
  };
  </script>

  <style scoped>
  .accordion .card .card-header {
      border-radius: 0!important;
      margin-bottom: -1px!important;
      background-color: #fff!important;
  }
  .card-header:first-child {
      border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0!important;
  }
  .card-header {
      padding: .75rem 1.25rem!important;
      margin-bottom: 0!important;
      background-color: rgba(0, 0, 0, .03)!important;
      border-bottom: 1px solid rgba(0, 0, 0, .125)!important;
  }
  .card-header span{
      color:#621132;
      /* transition: ease all .1s;
      font-weight: 400; */
  }
  .card-header span:hover{
      transform: scale(1.04);
      border: none !important;
  }
  .card-body .subtitulo{font-size: 1.1rem; font-weight: 700 !important; color:#6c757d;}
  .card-body .subsubtitulo{font-size: .95rem; font-weight: 500; color:#621132; margin: 3rem 1rem;}
  .card-body li {
      list-style-type: none;
      margin-bottom: 0.5rem;
      border-bottom: 1px dotted rgb(189, 182, 182);
      padding: .2rem;
      padding-left: 0 !important;
      font-size: 14px;
      transition: ease all .1s;
      /* display: flex; */
      justify-content: space-between;
      align-items: center;
  }
  .card-body li:hover{
       transform: scale(1.01);
  }
  .card-body ul li a.item-name {
      color: #000!important;
      text-decoration: none;
      cursor: pointer;
      flex-grow: 1;
  }
  .item-name .pie-titulo,
  .titulo .pie-titulo{
    font-size: .8rem;
    font-style: italic;
    color:#a1a1a1;
    margin-left: 10px;
  }
  .icons {
      display: flex;
      gap: 10px;
      font-size: 1.5rem;
  }
  .icons a {
      color: #000;
      transition: color 0.2s;
  }
  .icons a:hover {
      color: #007bff;
  }
  .icon-pdf{
      color: #e74c3c!important;
  }
  .icon-word {
      color: #007bff!important;
  }
  .icon-excel {
      color: #28a745!important;
  }
  .icon-rar {
      color: #f39c12!important;
  }
  </style>
